import PropTypes from 'prop-types';
import React from 'react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Select from '../../../common/select';
import CheckboxSwitch from '../../../common/checkboxSwitch';

const frequency = [{
  value: 1,
  label: 'Daily',
}, {
  value: 7,
  label: 'Weekly',
}, {
  value: 14,
  label: '2 Weeks',
}, {
  value: 21,
  label: '3 Weeks',
}, {
  value: 28,
  label: '4 Weeks',
}];

const ReccuringBlockTime = ({ showFrequency, showUpdateAllRecurring, id }) => (
  <div>
    <div className="layout__item" display-if={showUpdateAllRecurring}>
      <CheckboxSwitch
        name="updateAllRecurring"
        id="updateAllRecurring"
        label="Update all future occurrences"
      />
    </div>
    <div className="layout__item" display-if={!id}>
      <CheckboxSwitch
        name="isRecurring"
        id="isRecurring"
        label="Repeat"
      />
      <div className="u-mt" display-if={showFrequency}>
        <div className="c-label-new">Frequency</div>
        <Select
          className="c-select"
          name="recurrEveryNumDays"
          options={frequency}
          valueField="value"
          textField="label"
          empty="Choose frequency"
          data-automation-id="select:recurrEveryNumDays"
        />
      </div>
    </div>

  </div>
);

ReccuringBlockTime.propTypes = {
  showFrequency: PropTypes.bool.isRequired,
};
ReccuringBlockTime.defaultProps = {};

const selector = formValueSelector('blockTime');

const mapStateToProps = state => ({
  showFrequency: selector(state, 'isRecurring'),
  showUpdateAllRecurring: selector(state, 'showUpdateAllRecurring'),
  id: selector(state, 'id'),
});

export default connect(mapStateToProps)(ReccuringBlockTime);
